import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 16 16" {...props}><path fill="#CCD0D4" d="M8 0a8 8 0 110 16A8 8 0 018 0zm2.924 5.062a.545.545 0 00-.771 0l-2.07 2.153-2.25-2.182a.545.545 0 10-.757.785l2.237 2.153-2.237 2.153a.545.545 0 10.757.785l2.25-2.182 2.07 2.153a.545.545 0 10.785-.756L8.855 7.942l2.083-2.182a.545.545 0 00-.014-.698z" /></svg>);